export enum HouseLandVacancyMenuEnum {
    overview = 0,
    landParcel
}
